import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { f as focusOutline } from '../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { g as globalStyles, t as transparentStyles, a as primaryStyles, b as defaultStyles, s as smallStyles, n as normalStyles, c as transparentloadingStyles, l as loadingStyles } from './Button.styles-Ck-xVxAl.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { I as Icon } from '../Icon/Icon-AcXbY_t4.js';
import { s as spinner } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const StyledButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40027066__sc-d3w8xm-0"
})(["", ";", ";", ";", ";&&:focus-visible{", "}margin:0;"], globalStyles, ({
  $primary,
  $transparent
}) => {
  if ($transparent) {
    return transparentStyles;
  }
  if ($primary) {
    return primaryStyles;
  }
  return defaultStyles;
}, ({
  $small
}) => $small ? smallStyles : normalStyles, ({
  $loading,
  $transparent
}) => {
  if ($loading) {
    if ($transparent) {
      return transparentloadingStyles;
    }
    return loadingStyles;
  }
  return undefined;
}, focusOutline);
const Button = ({
  buttonRef,
  disabled,
  variant = 'default',
  small,
  type = 'button',
  loading,
  loadingLabel,
  iconStart,
  iconEnd,
  children,
  taktId,
  taktValue,
  onClick,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('button')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, getDataTaktAttributes(), rest, {
  disabled: disabled,
  type: type,
  ref: buttonRef,
  $primary: variant === 'primary',
  $small: small,
  $transparent: variant === 'transparent',
  $loading: loading
}, loading && {
  'aria-live': 'assertive'
}, (loading || disabled) && {
  'aria-disabled': true
}, {
  onClick: loading ? undefined : onClick
}), loading ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
  type: spinner
}), loadingLabel || children) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, iconStart && /*#__PURE__*/React__default.createElement(Icon, {
  type: iconStart,
  size: small ? 'xsmall' : 'small'
}), children, iconEnd && /*#__PURE__*/React__default.createElement(Icon, {
  type: iconEnd,
  size: small ? 'xsmall' : 'small'
}))));

export { Button as B };
//# sourceMappingURL=Button-BzSULnj6.js.map
